import {
  Brand,
  Category,
  ProductsIcon,
  SettingsIcon,
  Certificate,
  Comment,
  Video,
  Banner,
  Branches,
  Assets,
  Lang,
} from "assets/images/icons";

interface MenuItem {
  key: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  children?: MenuItem[];
  route?: string;
  border?: boolean;
}

const SuperAdminMenus: MenuItem[] = [
  {
    key: "categories",
    label: "Kategoriyalar",
    icon: <Category />,
    route: "/categories",
  },
  {
    key: "partners",
    label: "Hamkorlar",
    icon: <Brand />,
    route: "/partners",
  },
  {
    key: "products",
    label: "Mahsulotlar",
    icon: <ProductsIcon />,
    route: "/products",
  },
  // {
  //   key: "certificates",
  //   label: "Sertifikatlar",
  //   icon: <Certificate />,
  //   route: "/certificates",
  // },
  {
    key: "testimonials",
    label: "Izohlar",
    icon: <Comment />,
    route: "/testimonials",
  },
  {
    key: "video",
    label: "Videolar",
    icon: <Video />,
    route: "/videos",
  },
  {
    key: "news",
    label: "Yangiliklar",
    icon: <Banner />,
    route: "/news",
  },

  {
    key: "vacancy",
    label: "Vakansiyalar",
    icon: <Certificate />,
    route: "/vacancy",
  },
  // {
  //   key: "condidates",
  //   label: "Kondidatlar",
  //   icon: <Comment />,
  //   route: "/condidates",
  // },
  {
    key: "banner",
    label: "Bannerlar",
    icon: <Banner />,
    route: "/banner",
  },
  {
    key: "assets",
    label: "Sozlamalar",
    icon: <Assets />,
    route: "/assets",
  },
  {
    key: "localization",
    label: "Tarjimalar paneli",
    icon: <Lang />,
    route: "/localization",
  },
];

const getMenu = (role: any) => {

      return SuperAdminMenus;

};

export default getMenu;
